import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { processError, getPaginationInfo } from '../../lib/lib.js'
import { Card, CardHeader, CardBody, CardFooter, Button, Row, Col, CardImg, Spinner } from 'reactstrap'
import { NewspaperClipping } from "phosphor-react"
import SearchItems from '../../components/Search/SearchItems.jsx'
import noData from '../../assets/img/search/noData.svg'
import api from '../../api/api.js'
import Cookies from 'universal-cookie'
import NewsCard from '../../components/News/NewsCard.jsx'
const cookies = new Cookies()

class Search extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            groups: [],
            loading: true,
            page: 1,
            limit: 3,
            news: [],
        }
        this.pictureLoaded = this.pictureLoaded.bind(this)
    }

    getNews(data) {
        return new Promise((resolve, reject) => {
            api.getNews(data)
                .then((res) => resolve(res))
                .catch((e) => {
                    processError(e, this.props.history)
                    reject(e)
                })
        })
    }

    pictureLoaded() {
        this.setState({ loading: false })
    }

    componentWillMount() {
        const groups = this.props.location.state.groups.filter((item) => item.data.length)
        this.setState({ groups })
        if (!groups.length) {
            const { limit, page } = this.state
            const token = cookies.get('accessToken')
            const lang = this.props.i18n.language
            const { end, start } = getPaginationInfo({ page, limit })
            this.getNews({ token, lang, end, start }).then(({ rows }) => this.setState({ news: rows, newsLoaded: true }))
        }
    }

    render() {
        const { t } = this.props
        return (
            <div className="search-bg position-relative">
                {
                    this.state.groups.length ?
                        this.state.groups.map((item, index) => (
                            <SearchItems key={index} title={item.name} items={item.data} props={this.props} />
                        )) :
                        <Row className="search-items w-100 mx-0">
                            <Col xs={9} className="px-0">
                                <Card className="empty-search-card m-0">
                                    <CardHeader>{t('search-no-result')}</CardHeader>
                                    <CardBody>
                                        <Spinner
                                            className={this.state.loading ? '' : 'd-none'}
                                            as="span"
                                            animation="grow"
                                            style={{ width: '3rem', height: '3rem' }}
                                            role="status"
                                            aria-hidden="true"
                                        />
                                        <CardImg
                                            src={noData}
                                            alt=""
                                            onLoad={this.pictureLoaded}
                                            className={this.state.loading ? 'd-none' : ''}
                                        />
                                    </CardBody>
                                    {/* <div className="card-desc">{t('study-available')}</div> */}
                                    <CardFooter>
                                        <Button className="empty-search-btn" onClick={() => this.props.history.push('/news/1')}>
                                            <NewspaperClipping size={20} className="primary" />
                                            <span className="text">{t('news-news')}</span>
                                        </Button>
                                    </CardFooter>
                                </Card>
                                <div style={{ padding: '0 20px' }}>
                                    <Row>
                                        {
                                            this.state.newsLoaded ?
                                                this.state.news.map((item) => (
                                                    <NewsCard key={item.id}
                                                        id={item.id}
                                                        name={item.title}
                                                        date={item.date}
                                                        desc={item.desc}
                                                        props={this.props}
                                                        page={1}
                                                        imgPreview={item.image}
                                                    />
                                                ))
                                                :
                                                <React.Fragment>
                                                    <NewsCard skeleton={true}/>
                                                    <NewsCard skeleton={true}/>
                                                    <NewsCard skeleton={true}/>
                                                </React.Fragment>
                                        }
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                }
            </div>
        )
    }
}

Search.propTypes = {
    i18n: PropTypes.object,
    t: PropTypes.func,
    location: PropTypes.object,
    history: PropTypes.object,
}

export default withTranslation()(Search)



// WEBPACK FOOTER //
// ./src/views/Search/Search.jsx